import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "41667ef9-37b6-4ac4-988f-1dd1b43bdf49",
    content: "The standard deviations at lower frequencies are lower than at higher frequencies.",
    options: {},
  },
  {
    id: "34d57f9c-d307-4134-9552-be9965144ad7",
    content: "The standard deviations are the same at lower and higher frequencies.",
    options: {},
  },
  {
    id: "a716383c-207f-43ac-ae9e-5fd7ce75f849",
    content: "The standard deviations are higher at lower frequencies compared to higher frequencies.",
    options: {},
  },
  {
    id: "3d5181d0-5255-4ef9-b5be-409669dd075d",
    content: "The standard deviations can not be determined.",
    options: {},
  },
];

export const task: Task = {
  id: "114d54c2-b571-481b-8dd0-a55d67fe35e9",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["a716383c-207f-43ac-ae9e-5fd7ce75f849"],
};
